import { render, staticRenderFns } from "./welcome_component.vue?vue&type=template&id=500e854e&scoped=true"
import script from "./welcome_component.vue?vue&type=script&lang=js"
export * from "./welcome_component.vue?vue&type=script&lang=js"
import style0 from "./welcome_component.vue?vue&type=style&index=0&id=500e854e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e854e",
  null
  
)

export default component.exports